import { useEffect, useMemo, useState } from 'react';

interface PopupTabConfig {
  name: string;
}

export function usePopupTabs<T extends PopupTabConfig>(
  popupConfig: T[],
  activeTab: number | undefined,
  open: boolean,
  tabsRenderExclude: { [key: string]: boolean } = {}
) {
  const initialTabIndex = activeTab !== undefined ? activeTab : 0;
  const [activeTabIndex, setActiveTabIndex] = useState(initialTabIndex);

  useEffect(() => {
    if (open) {
      setActiveTabIndex(activeTab !== undefined ? activeTab : 0);
    }
  }, [activeTab, open]);

  const renderConfig = useMemo(
    () =>
      popupConfig.map((conf) => ({
        ...conf,
        skip: Boolean(tabsRenderExclude[conf.name]),
      })),
    [popupConfig, tabsRenderExclude]
  );

  return { activeTabIndex, setActiveTabIndex, renderConfig };
}
